import { EnvTopic } from '@/domain/impact-env/entities/question.entity';
import { EssTopic } from '@/domain/impact-ess/entities/question.entity';
import { ProjectMode } from '@/domain/project/project.slice';

export type TopicsGlobalScoreData = {
  projectMode: ProjectMode;
  co2: {
    scoreLetter: string;
    score: number;
    kgeCO2ByParticipant: number;
  };
  ess: {
    scoreLetter: string;
    score: number;
    maxScore: number;
  };
  env: {
    scoreLetter: string;
    score: number;
    maxScore: number;
  };
};

export type TopicsScores = {
  co2: string;
  env: string;
  ess: string;
  totalMen: string;
  totalWomen: string;
  totalOther: string;
};

export const EnvTopicValues = [
  EnvTopic.GLOBAL_CO2,
  EnvTopic.FOOD_BEVERAGES,
  EnvTopic.RESOURCES_POLLUTION,
  EnvTopic.COMMUNICATION,
  EnvTopic.PUBLIC_ENGAGEMENT,
  EnvTopic.EQUIPMENT_AND_SCENOGRAPHY,
] as const;

export const EssTopicValues = [
  EssTopic.PARITY_EQUALITY,
  EssTopic.ACCESSIBILITY_SOCIAL_DIALOGUE,
  EssTopic.LOCAL_IMPACT_RSE_ENGAGEMENT,
] as const;
